import { clsx } from 'clsx';
import { FC, PropsWithChildren, ReactElement } from 'react';
import { SslIcon, TrustedIcon } from 'molecules/Header/Wrapper/Icons';
import { useGTMCurrentBasket } from 'modules/gtm/modules/sections/cart/hooks';
import { useGTMCurrentWishlist } from 'modules/gtm/modules/sections/wishlist/hooks';
import styles from './styles.module.css';

export const Wrapper: FC<
  PropsWithChildren & { rightPanel?: ReactElement; className?: string }
> = ({ children, className = '', rightPanel }) => {
  return (
    <div className={clsx(styles.root, className)}>
      <div className={styles.content}>{children}</div>
      {rightPanel}
    </div>
  );
};

export const HeaderWithIcon: FC<PropsWithChildren<{ className?: string }>> = ({
  children,
}) => {
  return (
    <Wrapper
      rightPanel={
        <div className={styles.icons}>
          <TrustedIcon />
        </div>
      }
    >
      {children}
    </Wrapper>
  );
};

export const HeaderWithTwoIcons: FC<
  PropsWithChildren<{ className?: string }>
> = ({ children }) => {
  useGTMCurrentWishlist();
  useGTMCurrentBasket();

  return (
    <Wrapper
      rightPanel={
        <div className={styles.icons}>
          <TrustedIcon />
          <SslIcon />
        </div>
      }
    >
      {children}
    </Wrapper>
  );
};
